import React, { useEffect, useState } from 'react'
import { t } from 'ttag'
import { CustomType, GoalWithProgress } from '../../services/api.types'
import makeStyles from '@material-ui/core/styles/makeStyles'
import YumButton from '../YumButton/YumButton'
import YumDrawer from '../YumDrawer/YumDrawer'
import YumGrid from '../YumGrid/YumGrid'

import { ReactComponent as DrawerCloseIcon } from '../../assets/v3/icons/ranking/drawer-close.svg'
import { Capacitor, PluginListenerHandle } from '@capacitor/core'
import { Keyboard } from '@capacitor/keyboard'
import YumManualEntryFormWrapper from '../YumManualEntryForm/YumManualEntryFormWrapper'
import { isActivityIndexType } from '../../common/helpers/challenges'

export interface IStateProps {
  goal: GoalWithProgress
  disabled: boolean
  autoClose: boolean
}

const useStyles = makeStyles((theme) => ({
  button: {
    /*display: 'inline-block',
    padding: '0 10px',
    lineHeight: '32px',
    fontSize: 15,
    fontWeight: 'bold',
    borderRadius: 8,
    width: 'auto',
    minWidth: 'auto',
    margin: 0,
    textTransform: 'none',*/
  },

  header: {
    marginBottom: '16px',
  },
  title: {
    fontSize: '17px',
    fontWeight: 700,
    lineHeight: '20px',
  },
  closeButton: {
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
    },
  },

  bottomSafeArea: {
    /*transition: 'padding ease-in-out 150ms',
    paddingBottom: '16px',

    /!* iOS Safari 11.2, Safari 11 *!/
    '@supports (bottom: constant(safe-area-inset-bottom))': {
      paddingBottom: 'constant(safe-area-inset-bottom)',
    },

    /!* iOS Safari 11.4+, Safari 11.1+, Chrome 69+, Opera 56+ *!/
    '@supports (bottom: env(safe-area-inset-bottom))': {
      paddingBottom: 'env(safe-area-inset-bottom)',
    },*/
  },
}))

export default function YumLogActivity(props: IStateProps) {
  const { goal, disabled, autoClose } = props
  const classes = useStyles()

  let keyboardWillShowListener: PluginListenerHandle
  let keyboardWillHideListener: PluginListenerHandle
  useEffect(() => {
    //syncProgress()

    const addListeners = async () => {
      if (Capacitor.getPlatform() === 'ios') {
        keyboardWillShowListener = await Keyboard.addListener('keyboardWillShow', (info) => {
          const contentEl = document.getElementById('yum-drawer')?.getElementsByClassName('MuiPaper-root')[0]
          if (contentEl) {
            const safeAreaInsetBottom = parseInt(
              getComputedStyle(document.documentElement).getPropertyValue('--safe-area-inset-bottom'),
            )
            // @ts-ignore
            contentEl.style.transform = `translate(0px, -${info.keyboardHeight - safeAreaInsetBottom}px)`
            //contentEl.style.paddingBottom = `${info.keyboardHeight - parseInt(safeAreaInsetBottom)}px`
            //contentEl.style.transform = `translate(0px, -${info.keyboardHeight}px)`
            //contentEl.style.marginBottom = info.keyboardHeight + 'px'
          }
        })
        keyboardWillHideListener = await Keyboard.addListener('keyboardWillHide', () => {
          const contentEl = document.getElementById('yum-drawer')?.getElementsByClassName('MuiPaper-root')[0]
          if (contentEl) {
            // @ts-ignore
            contentEl.style.transform = `translate(0px, 0px)`
            //contentEl.style.paddingBottom = '0px'
            //contentEl.style.marginBottom = '0px'
          }
        })
      }
    }

    addListeners().catch(console.error)

    return () => {
      keyboardWillShowListener?.remove()
      keyboardWillHideListener?.remove()
    }
  }, [])

  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const onSubmit = () => {
    if (autoClose) {
      setOpen(false)
    }
  }

  return (
    <>
      <YumButton
        size="medium"
        className={classes.button}
        onClick={handleOpen}
        disabled={disabled}
      >{t`Manual entry`}</YumButton>
      {!disabled && (
        <YumDrawer open={open} onClose={handleClose} onOpen={handleOpen}>
          <YumGrid className={classes.header}>
            <div className={classes.title}>{t`Manual entry`}</div>
            <DrawerCloseIcon onClick={handleClose} className={classes.closeButton} />
          </YumGrid>
          <div className={classes.bottomSafeArea}>
            <YumManualEntryFormWrapper goal={goal} onSubmit={onSubmit} />
          </div>
        </YumDrawer>
      )}
    </>
  )
}
